/**
 * Typed API client for Task extensions — checklists, dependencies, time logs.
 *
 * Mirrors internal/tasksext. These augment a base task (from /tasks) with
 * sub-items, blocking relationships, and logged effort.
 */

import { apiClient } from '@/lib/apiClient';

export interface ChecklistItem {
  id: string;
  text: string;
  completed: boolean;
  sortOrder: number;
}

export interface TaskDependency {
  id: string;
  dependsOnTaskId: string;
  depType: string;
}

export interface TaskTimeLog {
  id: string;
  userId: string;
  minutes: number;
  notes?: string | null;
  loggedAt: string;
}

export async function listChecklist(taskId: string): Promise<ChecklistItem[]> {
  const { data } = await apiClient.get<ChecklistItem[]>(`/tasks-ext/${taskId}/checklist`);
  return data;
}

export async function addChecklistItem(taskId: string, text: string, sortOrder?: number): Promise<{ id: string }> {
  const { data } = await apiClient.post<{ id: string }>(`/tasks-ext/${taskId}/checklist`, { text, sortOrder });
  return data;
}

export async function toggleChecklistItem(id: string, completed: boolean): Promise<{ ok: boolean }> {
  const { data } = await apiClient.patch<{ ok: boolean }>(`/tasks-ext/checklist/${id}`, { completed });
  return data;
}

export async function listDependencies(taskId: string): Promise<TaskDependency[]> {
  const { data } = await apiClient.get<TaskDependency[]>(`/tasks-ext/${taskId}/dependencies`);
  return data;
}

export async function addDependency(
  taskId: string,
  dependsOnTaskId: string,
  depType?: string,
): Promise<{ id: string }> {
  const { data } = await apiClient.post<{ id: string }>(`/tasks-ext/${taskId}/dependencies`, {
    dependsOnTaskId,
    depType,
  });
  return data;
}

export async function listTimeLogs(taskId: string): Promise<TaskTimeLog[]> {
  const { data } = await apiClient.get<TaskTimeLog[]>(`/tasks-ext/${taskId}/time`);
  return data;
}

export async function logTime(taskId: string, minutes: number, notes?: string): Promise<{ id: string }> {
  const { data } = await apiClient.post<{ id: string }>(`/tasks-ext/${taskId}/time`, { minutes, notes });
  return data;
}
